import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & { size?: number };

const base = (props: Props) => ({
  width: props.size ?? 20,
  height: props.size ?? 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
});

export const SparklesIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7L12 3z" />
    <path d="M18 14l.9 2.1L21 17l-2.1.9L18 20l-.9-2.1L15 17l2.1-.9L18 14z" />
  </svg>
);

export const TextIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M4 7h16M4 12h10M4 17h16" />
  </svg>
);

export const PenIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M17 3l4 4-11 11H6v-4L17 3z" />
    <path d="M14 6l4 4" />
  </svg>
);

export const LightbulbIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M9 18h6M10 21h4" />
    <path d="M12 3a6 6 0 00-4 10.5c.7.7 1 1.6 1 2.5v2h6v-2c0-.9.3-1.8 1-2.5A6 6 0 0012 3z" />
  </svg>
);

export const CheckListIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M9 6h12M9 12h12M9 18h12" />
    <path d="M3 5.5l1.5 1.5L7 4M3 11.5L4.5 13 7 10M3 17.5L4.5 19 7 16" />
  </svg>
);

export const MailIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

export const TargetIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.5" />
  </svg>
);

export const ChatIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M4 5h16v11H8l-4 4V5z" />
    <path d="M8 10h8M8 13h5" />
  </svg>
);

export const ToolsIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M14 4a4 4 0 00-1 7l-7 7 2 2 7-7a4 4 0 005-5l-3 3-2-2 3-3a4 4 0 00-4-2z" />
  </svg>
);

export const ClockIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const BookmarkIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M6 3h12v18l-6-4-6 4V3z" />
  </svg>
);

export const SettingsIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1A1.7 1.7 0 004.6 9a1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />
  </svg>
);

export const CopyIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15V5a2 2 0 012-2h10" />
  </svg>
);

export const BookmarkAddIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M6 3h12v18l-6-4-6 4V3z" />
    <path d="M12 8v6M9 11h6" />
  </svg>
);

export const TrashIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M4 7h16M10 11v6M14 11v6" />
    <path d="M5 7l1 13a2 2 0 002 2h8a2 2 0 002-2l1-13" />
    <path d="M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3" />
  </svg>
);

export const SunIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

export const MoonIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M21 13.5A8.5 8.5 0 0110.5 3a7 7 0 1010.5 10.5z" />
  </svg>
);

export const PlusIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const SearchIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="M16 16l5 5" />
  </svg>
);

export const SendIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M3 20l18-8L3 4v6l12 2-12 2v6z" />
  </svg>
);

export const SignOutIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <path d="M16 17l5-5-5-5M21 12H9" />
  </svg>
);

export const CheckIcon = (props: Props) => (
  <svg {...base(props)} {...props}>
    <path d="M5 12l5 5L20 7" />
  </svg>
);
